$(document).on('change', '[data-get-districts]', function () {

    const csrf = $(this).data('csrf'),
        city_id = $(this).val(),
        el_target = $($(this).data('target'));

    if (!city_id){

        return el_target.children(':not(:first-child)').remove();

    }

    $.ajax({
        type: 'GET',
        url: App.prototype.apiAddress + 'cities/' + city_id + '/districts?_token=' + csrf,
        dataType: "json",
        success: function( response ) {
            el_target.children(':not(:first-child)').remove();

            if (response && response.length){

                for (const responseElement of response) {

                    el_target.append('<option value="' + responseElement.id + '">' + responseElement.name + '</option>');

                }

            }
        }
    });
});
